(function() {
  $('#SingleOptionSelector-0').change(function() {
    var val = $(this).val();
    if ( val.indexOf('袋') != -1 || val.indexOf('アルミ') != -1 || val.indexOf('セット') != -1) {
      $('#SingleOptionSelector-1').val('なし');
      $('#SingleOptionSelector-2').val('なし');
      $('#SingleOptionSelector-1').prop('disabled', true);
      $('#SingleOptionSelector-2').prop('disabled', true);      
    }else if ( val.indexOf('缶') != -1) {
      $('#SingleOptionSelector-1').prop('disabled', false);
      $('#SingleOptionSelector-2').prop('disabled', false);      
      $('#SingleOptionSelector-1').val('レギュラーデザイン');
      $('#SingleOptionSelector-2').val('なし');
    }
    if ( val.indexOf('セット') != -1) {
      $('#SingleOptionSelector-1').val('なし');
      $('#SingleOptionSelector-1').prop('disabled', false);
    }
  });
  
  //var navPosition = $('.site-header').offset().top;
  var navPosition = 0,winScrollTop=0;
  /*var navHeight = $('.site-header').outerHeight();*/
  var navHeight = 85;
  $(window).on('scroll', function() {
    winScrollTop = $(this).scrollTop();
    if (winScrollTop >= navPosition) {
      $('body').css( 'padding-top', 0 );
      $('.site-header').removeClass('sticky');
    } else {
      $('body').css('padding-top', navHeight);
      $('.site-header').addClass('sticky');
    }
    navPosition = winScrollTop;
  });
    
  if (swiper_02_true == 1) {
    const swiper_02 = new Swiper(".product_item_wrap_02_02_swiper", {
     loop: true,
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  };
  
  if (swiper_03_true == 1) {
    const swiper_03 = new Swiper(".product_item_wrap_03_01_swiper", {
      loop: true,
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  };
  
  if (swiper_04_true == 1) {
    const swiper_04 = new Swiper(".product_item_wrap_04_01_swiper", {
      loop: true,
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  };
  
  if (swiper_05_true == 1) {  
    const swiper_05 = new Swiper(".product_item_wrap_04_02_swiper", {
      loop: true,
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  };

  if (swiper_06_true == 1) {  
    const swiper_06 = new Swiper(".product_item_wrap_12_02_swiper", {
      loop: true,
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  };

  if (swiper_07_true == 1) {
    //swiper
    const swiper_08 = new Swiper(".product_item_wrap_20_05", {
      direction: "vertical", // スライダーの向きを縦にする
      spaceBetween: 5,
      slidesPerView: 4,
      slideToClickedSlide: true,
      loopAdditionalSlides: 8,
    });  

    const swiper_07 = new Swiper(".product_item_wrap_20_03", {
      loop: true,
      // ページネーションが必要なら追加
      /*pagination: {
        el: ".swiper-pagination",
        type: "fraction"
      },*/
      thumbs: {
        swiper: swiper_08
      },    
      // ナビボタンが必要なら追加
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  };
  

  
})();

